import type { Block, ImageRef, Text } from '@ksa/model'
import { SiteImage, SiteText, hasText } from '../context.tsx'

type Member = { photo: ImageRef; name: Text; role: Text }
type Props = { heading: Text; members: Member[] }

export function TeamBlock({ block }: { block: Block }) {
  const p = block.props as unknown as Props
  const members = p.members ?? []

  return (
    <section className="s-section">
      <div className="s-wrap s-stack-lg">
        {hasText(p.heading) && (
          <h2 className="s-h2 s-center">
            <SiteText value={p.heading} />
          </h2>
        )}
        <ul className="s-grid s-grid--4" style={{ listStyle: 'none', margin: 0, padding: 0 }}>
          {members.map((m, i) => (
            <li key={i}>
              <SiteImage image={m.photo} />
              <p className="s-h3" style={{ marginBlockStart: '0.75rem' }}>
                <SiteText value={m.name} />
              </p>
              {hasText(m.role) && (
                <p className="s-small" style={{ color: 'var(--muted)' }}>
                  <SiteText value={m.role} />
                </p>
              )}
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
